import React from 'react';

interface HeaderProps {
  title: string;
  learnMoreLink?: string;
}

const Header: React.FC<HeaderProps> = ({ title, learnMoreLink }) => {
  return (
    <header className="bg-trustkeysHeader text-white">
      <nav className="container mx-auto px-4 py-2 flex justify-between items-center">
        <img src="trustkeys.svg" alt="TrustKeys Network" className="h-12" />
      </nav>
    </header>
  );
};

export default Header;
